import React from 'react';
import {Redirect, Route} from "react-router-dom";
import {RouteComponentProps, StaticContext} from "react-router";
import {useSelector} from "react-redux";
import {StateType} from "../store/store";

type RouteProps = {
  [x: string]: any,
  component: React.ComponentType<any> | React.ComponentType<RouteComponentProps<any, StaticContext, unknown>>
}

export default function TeacherPrivateRoute({component: Component, ...rest}: RouteProps) {
  const teacherState = useSelector((state: StateType) => state.rootReducer.teacherReducer);
  const {data} = teacherState;
  return (
    <Route
      {...rest}
      render={(props =>
          data.role === "teacher" ? (
            <Component {...props} />
          ) : (
            <Redirect to={{pathname: "/auth"}}/>
          )
      )}
    />
  )
}